import { render, staticRenderFns } from "./ZhanhuiListBlock.vue?vue&type=template&id=0aab19e8&scoped=true"
import script from "./ZhanhuiListBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab19e8",
  null
  
)

export default component.exports